import { COLOR, line, period } from '../../specs'
import type { IndicatorDef } from '../../types'

const def: IndicatorDef = {
  id: 'WR',
  version: 2,
  label: 'Williams %R',
  pane: 'sub',
  category: 'momentum',
  series: 'normal',
  precision: 2,
  order: 60,
  inputs: [period('timeperiod', 14)],
  outputs: [line('willr', '%R', COLOR.purple)],
  levels: [{ value: -20 }, { value: -80 }],
  talib: { functions: ['WILLR'], expr: 'WILLR(high, low, close, timeperiod={timeperiod})' },
  listed: true,
  tailSafe: true,
  lookback: ({ timeperiod }) => timeperiod - 1,
}
export default def
